<template>
	<div class="account-page">
		<div class="account-page__content" v-if="user != null">

			<h3 class="header">Account Settings</h3>
			<section class="general-account-settings">
				<div class="section-header-wrapper">
					<h4 class="section-header">General Account Information</h4>
				</div>
				
				<div class="settings-wrapper">
					<div class="general-account-settings__group first-group">
						<div class="row-info">
							<p class="row-label">Name</p>
							<p class="row-data" v-if="!showEditName">{{ user.name }}</p>
							<div class="edit row-data" v-if="showEditName">
								<form @submit.prevent="saveName">
									<div class="form-group account-edit">
										<input type="text" class="account-edit__input" v-model="name" required>
									</div>
									<input type="submit" class="save-button" value="Save">
									<button class="cancel-button" @click.prevent="toggleEditName">Cancel</button>
								</form>
							</div>
						</div>
						<button class="row-action" @click.prevent="toggleEditName" v-if="!showEditName">Edit</button>
					</div>
					<div class="general-account-settings__group">
						<div class="row-info">
							<p class="row-label">Email</p>
							<p class="edit row-data" v-if="!showEditEmail">{{ user.email }}</p>
							<div class="edit row-data" v-if="showEditEmail">
								<form @submit.prevent="saveEmail">
									<div class="form-group account-edit">
										<input type="email" class="account-edit__input" v-model="email">
									</div>
									<input type="submit" class="save-button" value="Save">
									<button class="cancel-button" @click.prevent="toggleEditEmail">Cancel</button>
								</form>
								<p class="email-taken" v-if="emailTaken">It appears that email is already used by a different account. Please contact us at <span>support@meagur.com</span> if you believe this is an unauthorized use of your email address.</p>
							</div>
						</div>
						<button class="row-action" @click="toggleEditEmail" v-if="!showEditEmail">Edit</button>
					</div>
					<div class="general-account-settings__group last-group">
						<div class="row-info">
							<p class="row-label">Email Verification</p>
							<p class="row-data text-color--green" v-if="user.email_verified_at != null">Successfully Verified</p>
							<p class="row-data text-color--red" v-else>Not Currently Verified</p>
						</div>
						<button v-if="user.email_verified_at == null" class="row-action" @click="thisVerifyEmail">Verify Now</button>
					</div>
				</div>
			</section>
<!-- 			<section class="email-settings">
				<div class="section-header-wrapper">
					<h3 class="section-header">Email Settings</h3>
				</div>
				<p v-if="user.email_verified_at == null">Here you can set whether you want to receive notifications about upcoming events and reminders about deadlines to complete entries. To do this, we must first verify your email above.</p>
				<div class="settings-wrapper" v-else>
					
				</div>
			</section> -->
			<section class="password-settings">
				<div class="section-header-wrapper">
					<h4 class="section-header">Password Settings</h4>
				</div>
				<div class="password-currently-set">
					<p class="label">Password Currently Set:</p>
					<p class="setting" :class="{ 'text-color--green': user.password_set, 'text-color--red': !user.password_set }">{{ user.password_set ? 'Yes' : 'No' }}</p>
				</div>
				<div class="set-password" v-if="!user.password_set">
					<p>You can set a password to user for future logins if you'd like. <span v-if="user.email_verified_at == null">To do so, please first verify your email above.</span></p>
					<button class="set-password__action" v-if="user.email_verified_at != null" @click="setPassword">Set Password</button>
				</div>
				<div class="change-password" v-else>
					<button class="change-password__action" @click="SET_CHANGE_PASSWORD(true)">Change Password</button>
				</div>
			</section>

			<section class="social-accounts-settings">
				<div class="section-header-wrapper">
					<h4 class="section-header">Social Providers</h4>
				</div>
				<div class="providers-present" v-if="user.providers.length > 0">
					<p class="instructions">The following providers are currently connected to your account</p>
					<ul>
						<li v-for="provider in user.providers" :key="provider.provider">
							<p>{{ provider.provider.charAt(0).toUpperCase() + provider.provider.substring(1) }}</p>
							<button @click="thisRemoveSocialProvider(provider.id)">Remove</button>
						</li>
					</ul>
					<p class="only-one-provider" v-if="showOnlyOneProvider">Without a password set, you need to have at least one provider connected to your account.  If you'd like to remove it, please set a password above.</p>
				</div>
				<div class="providers-to-be-added" v-if="user.providers.length < 2">
					<p class="instructions">You can connect the following providers for future logins if you'd like</p>
					<facebook-login v-if="accountsThatCanBeAdded.includes('facebook')" class="facebook-login"  v-on:login="socialLogin"></facebook-login>
					<google-login v-if="accountsThatCanBeAdded.includes('google')" class="google-login"  v-on:login="socialLogin"></google-login>
					<div class="emails-do-not-match" v-if="emailsDoNotMatch">
						<p>The email for the account you provided and your email with Meagur do not match.  This will create a separate account with us, so we are unable to connect the social provider.  If you'd still like to connect it, you'll need to change the email we have on file with Meagur above.</p>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations, mapActions } from 'vuex'
	import axios from '@/axios'
	import GoogleLogin from '@/components/auth/ContinueWithGoogleButton'
	import FacebookLogin from '@/components/auth/ContinueWithFacebookButton'

	export default {
		components: {
			'google-login': GoogleLogin,
			'facebook-login': FacebookLogin,
		},
		data() {
			return {
				showEditName: false,
				name: '',
				showEditEmail: false,
				email: '',
				emailTaken: false,
				showOnlyOneProvider: false,
				emailsDoNotMatch: false
			}
		},
		computed: {
			...mapGetters([
				'user',
				'httpInProgress'
			]),
			accountsThatCanBeAdded() {
				if(this.user.providers.length == 0) {
					return [ 'facebook', 'google' ]
				} else if(this.user.providers.length == 1) {
					if(this.user.providers[0].provider == 'facebook') {
						return ['google']
					} else {
						return ['facebook']
					}
				} else {
					return []
				}
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED',
				'SET_USER',
				'SET_VERIFY_EMAIL',
				'SET_SET_PASSWORD',
				'SET_CHANGE_PASSWORD'
			]),
			...mapActions([
				'sendEmailVerificationLink',
				'loginWithProvider',
				'removeSocialProvider'
			]),
			toggleEditEmail() {
				if(this.showEditEmail == true) {
					this.email = this.user.email
					this.emailTaken = false
					this.showEditEmail = false
				} else {
					this.showEditName = false
					this.showEditEmail = true
				}
				
			},
			toggleEditName() {
				if(this.showEditName == true) {
					this.name = this.user.name
					this.showEditName = false
				} else {
					this.showEditEmail = false
					this.showEditName = true
				}
				
			},
			saveName() {
				this.HTTP_IN_PROGRESS()
				axios.patch('user', { name: this.name })
					.then(response => {
						this.SET_USER(response.data.data)
						this.toggleEditName()
						this.HTTP_FINISHED()
					}).catch(() => {
						this.HTTP_FINISHED()
					})
			},
			saveEmail() {
				this.HTTP_IN_PROGRESS()
				axios.patch('user', { email: this.email })
					.then(response => {
						this.SET_USER(response.data.data)
						this.toggleEditEmail()
						this.HTTP_FINISHED()
					}).catch(error => {
						if(error.response.data.code == 428) {
							this.emailTaken = true
						}
						this.HTTP_FINISHED()
					})
			},
			thisVerifyEmail() {
				this.sendEmailVerificationLink({ email: this.user.email })
					.then(() => {
						this.SET_VERIFY_EMAIL({ show: true, email: this.user.email, continueToSetPassword: false })
						this.HTTP_FINISHED()
					})
			},
			setPassword() {
				this.SET_SET_PASSWORD({ show: true, email: this.user.email })
			},
			socialLogin(provider) {
				this.showOnlyOneProvider = false
				this.emailsDoNotMatch = false
				const hello = this.hello

				hello(provider).login({ scope: 'email' }).then(() => {
					const authResponse = hello(provider).getAuthResponse()
					const context = this

					hello(provider).api('me').then(function(response) {
						if(response.email != context.user.email && response.email != null) {
							context.emailsDoNotMatch = true
						}

						if(context.emailsDoNotMatch) {
							return
						}

						context.loginWithProvider({
							provider: provider,
							token: authResponse.access_token
						}).then(() => {
							context.HTTP_FINISHED()
						}).catch(() => {
							context.HTTP_FINISHED()
						})				
						
					})

					
				})
			},
			thisRemoveSocialProvider(provider) {
				this.emailsDoNotMatch = false
				if(this.user.providers.length == 1 && !this.user.password_set) {
					this.showOnlyOneProvider = true
					return
				}
				this.removeSocialProvider(provider)
					.then(() => {
						this.HTTP_FINISHED()
					})
					.catch(() => {
						this.HTTP_FINISHED()
					})
			}
		},
		mounted() {
			if(this.user != null) {
				this.name = this.user.name
				this.email = this.user.email
			}
			
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/account';
</style>